import coverImg from '../../../media/papers/spike_bnab/cover.jpeg';
import spikeBnAbPDF from '../../../media/papers/spike_bnab/ijms-27-04025-v2.pdf';

const spikeImmuneEscapePaperData = {
    name: "SARS-CoV-2 Antibody Immune Escape",
    displayTitle: "SARS-CoV-2\nAntibody Immune Escape",
    category: "Computational Biology",
    tagline: "Mutational profiling and energy landscape analysis of broadly neutralizing antibodies targeting conserved spike epitopes",
    year: "2026",
    format: "MDPI",
    heroImage: coverImg,

    description: "Continued SARS-CoV-2 evolution has reduced efficacy of most monoclonal antibodies, yet broadly neutralizing antibodies targeting three conserved RBD epitopes (SCORE-A, SCORE-B, and SCORE-C) retain activity against recent JN.1-derived sublineages. This study combines conformational dynamics, mutational scanning, MM-GBSA binding energetics, and frustration profiling to analyze how XGI antibodies achieve broad neutralization and resist immune escape. All three epitopes share a conserved, minimally frustrated core for stable anchoring, with peripheral regions that accommodate antibody-specific variation while shaping escape pathways and fitness costs.",

    highlight: "Broad neutralization depends on anchoring to evolutionarily constrained cores; neutral frustration in RBD hotspots creates adaptable yet repeatable immune escape trajectories.",

    techStack: [
        "MM-GBSA",
        "Mutational Scanning",
        "Local Frustration Analysis",
        "Energy Landscape Theory",
        "Conformational Dynamics",
        "Structural Biology",
        "Computational Biology"
    ],

    documents: [
        {
            type: 'pdf',
            src: spikeBnAbPDF,
            title: 'Read Full Paper (PDF)',
            alt: 'Full research paper'
        },
        {
            type: 'link',
            src: 'https://www.mdpi.com/1422-0067/27/9/4025',
            title: 'View in Int. J. Mol. Sci.',
            alt: 'Published open-access article'
        },
        {
            type: 'link',
            src: 'https://doi.org/10.3390/ijms27094025',
            title: 'View DOI',
            alt: 'Digital object identifier'
        }
    ],
    documentTitle: "Publication"
};

export default spikeImmuneEscapePaperData;
